import SectionHeading from '@/components/base/SectionHeading';
import { RULES } from '@/mocks/arrangement';

export default function RulesSection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100" aria-labelledby="rules-heading">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <SectionHeading
            id="rules-heading"
            eyebrow="Rules"
            title="评审与参赛规则"
            desc="报名即视为同意以下规则。组委会对规则保留最终解释权，如有调整会提前在公告区说明。"
          />
        </div>
        <div className="lg:col-span-8">
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {RULES.map((r) => (
              <li key={r.id} className="rounded-lg border border-background-200 bg-background-50 p-5">
                <div className="flex items-start gap-3">
                  <span className="w-6 h-6 shrink-0 flex items-center justify-center mt-0.5">
                    <i className="ri-shield-check-line text-lg text-secondary-500"></i>
                  </span>
                  <div>
                    <h3 className="text-sm md:text-base font-semibold text-foreground-950">{r.title}</h3>
                    <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{r.text}</p>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}